// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__aC6rU","modalOverlay":"Modal_modalOverlay__2Bc7U","closeButton":"Modal_closeButton__jA3MB"};